import { render, staticRenderFns } from "./UnprocessedPayments.vue?vue&type=template&id=84ef8e06&"
import script from "./UnprocessedPayments.vue?vue&type=script&lang=js&"
export * from "./UnprocessedPayments.vue?vue&type=script&lang=js&"
import style0 from "./UnprocessedPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports